import { Component, inject } from '@angular/core';
import { AppToastService } from '../../../services/app-toast.service';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-toast-host',
  imports: [ToastComponent],
  host: {
    class: 'fixed flex flex-col gap-4 bottom-4 right-2 z-[100]',
  },
  template: `
    @for (toast of activeToasts(); track toast.id) {
      <app-toast
        [hosted]="true"
        [triggerToast]="true"
        [toastTitle]="toast.title"
        [toastMessage]="toast.message"
        [timeoutLength]="toast.timeoutLength ?? 5000"
        [persistent]="toast.persistent ?? false"
        (closed)="onToastClosed(toast.id)" />
    }
  `,
})
export class AppToastHostComponent {
  private readonly appToastService = inject(AppToastService);

  readonly activeToasts = this.appToastService.activeToasts;

  onToastClosed(id: string): void {
    this.appToastService.dismiss(id);
  }
}
